import React from "react";
import { GroupedWeeklySchedule } from "./types";

type StoreScheduleSummaryProps = {
  schedule: GroupedWeeklySchedule;
};

const rowStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "8px 0",
  borderBottom: "1px solid var(--border)",
  fontSize: "14px",
};

export default function StoreScheduleSummary({ schedule }: StoreScheduleSummaryProps) {
  return (
    <div>
      {schedule.map((group, idx) => {
        const times = (group.enabled ? group.passes : [])
          .map((p) => (p.time || "").trim())
          .filter(Boolean);

        const isLast = idx === schedule.length - 1;

        return (
          <div
            key={group.key}
            style={{
              ...rowStyle,
              borderBottom: isLast ? "none" : rowStyle.borderBottom,
            }}
          >
            <span style={{ fontWeight: 700, color: "var(--text-primary)" }}>{group.label}</span>
            <span
              style={{
                color: times.length ? "var(--text-primary)" : "var(--text-secondary)",
                fontFamily: times.length ? "monospace" : undefined,
              }}
            >
              {times.length ? times.join(" · ") : "—"}
            </span>
          </div>
        );
      })}
    </div>
  );
}
